import { render } from "./PasswordReset.vue?vue&type=template&id=6679c0bc"
import script from "./PasswordReset.vue?vue&type=script&lang=ts"
export * from "./PasswordReset.vue?vue&type=script&lang=ts"

import "./PasswordReset.vue?vue&type=style&index=0&id=6679c0bc&lang=css"
script.render = render

export default script